<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 发票信息 -->
          <div class="ttshop_coupon min_h">
            <div class="flexsb">
              <div class="fap_title">发票信息管理</div>
              <div class="add_fap" @click="addinvoice">新增发票抬头</div>
            </div>
            <!-- 列表卡片 -->
            <div class="invoive_main" v-if="invoicelist && invoicelist.length">
              <el-card
                class="m20"
                v-for="(item, index) in invoicelist"
                :key="index"
                @click.native="invoice_detail(item)"
              >
                <div class="box-card">
                  <div class="qitext" v-if="item.type == 1">个</div>
                  <div class="qitext" v-if="item.type == 2">企</div>
                  <div style="width: 100%">
                    <div class="flex">
                      <div class="invoice_gsname">{{ item.header }}</div>
                    </div>
                    <div class="dutyparagraph m20" v-if="item.taxpayer">
                      税号：{{ item.taxpayer }}
                    </div>
                    <div class="dutyparagraph m20 flexsb">
                      <div v-if="item.invoice_type == 0">
                        发票类型：增值税普通发票
                      </div>
                      <div v-else-if="item.invoice_type == 1">
                        发票类型：增值税普通发票
                      </div>
                      <div v-else-if="item.invoice_type == 2">
                        发票类型：增值税专用发票
                      </div>
                      <div class="flex">
                        <!-- <div
                          class="f12"
                          v-if="item.is_default==0"
                          @click.stop="settingdefa(item.id)"
                        >
                          设为默认
                        </div> -->
                        <div
                          style="cursor: pointer;"
                          class="f12"
                          @click.stop="inviocecompile(item)"
                        >
                          编辑
                        </div>
                        <div
                          style="cursor: pointer;"
                          class="f12"
                          @click.stop="delinvoice(item.id)"
                        >
                          删除
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
            <div v-else>
              <div class="ttshop_zuxiaofei">
                <img
                  class="img-default"
                  src="../../assets/images/ttshop_zanwu.png"
                  alt=""
                />
                <p>您目前暂无任何发票</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 专用发票无法选择提示 -->
    <el-dialog
      title="提示"
      :visible.sync="invoiceTipVisible"
      width="30%"
      center
    >
      <p style="font-size: 14px;">
        暂不支持新增、编辑增值税专用发票信息，如需帮助请联系：010-88811106
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="invoice_tip_btn"
          type="primary"
          @click="invoiceTipVisible = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
export default {
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      invoicelist: [],
      invoiceTipVisible: false,
    };
  },
  mounted() {},
  created() {
    this.getinvoice();
  },
  methods: {
    getinvoice() {
      var that = this;
      this.$api
        .getinvoivelist({
          type: "",
        })
        .then((res) => {
          if (res.code == 0) {
            that.invoicelist = res.data.list;
          } else {
            that.invoicelist = [];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    invoice_detail(item) {
      this.$router.push({
        path: "/ttshop_invoiceIfdetails",
        query: {
          id: item.id,
        },
      });
    },
    addinvoice() {
      this.$router.push({
        path: "/ttshop_addinvoice",
      });
    },
    // 删除发票
    delinvoice(id) {
      var that = this;
      this.$confirm("确认是否要删除此发票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.removeinvo(id);
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    removeinvo(id) {
      var that = this;
      this.$api
        .delinvoice({
          id: id,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$message({
              type: "success",
              message: "删除成功!",
            });
            setTimeout(function() {
              that.getinvoice();
            }, 500);
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 编辑发票
    inviocecompile(item) {
      if (item.invoice_type != 2) {
        this.$router.push({
          path: "/ttshop_addinvoice",
          query: {
            id: item.id,
          },
        });
      } else {
        this.invoiceTipVisible = true;
      }
    },
    // 设定默认
    settingdefa(id) {
      var that = this;
      this.$api
        .setinvoice({
          id: id,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.$message({
              message: "设定成功",
              type: "warning",
            });
            that.getinvoice();
          } else {
            that.$message({
              message: "" + res.msg,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.invoive_main {
  margin-top: 29px;
}
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 24px 20px;
  box-sizing: border-box;
  .flexsb {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .fap_title {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    .add_fap {
      width: 114px;
      height: 30px;
      background: #ff0e25;
      border-radius: 2px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      line-height: 30px;
    }
  }
  .box-card {
    display: flex;
    .qitext {
      width: 18px;
      height: 18px;
      background: #fff0f1;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff3259;
      text-align: center;
      line-height: 18px;
      margin-right: 4px;
    }
  }
  .flex {
    display: flex;
    align-items: center;

    .invoice_gsname {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }
  .dutyparagraph {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .m20 {
    margin-top: 20px;
  }
  .f12 {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #0e9cff;
    margin-left: 24px;
  }
}
.ttshop_zuxiaofei {
  width: 100%;
  padding-top: 150px;
  box-sizing: border-box;
  img {
    display: block;
    width: 93px;
    height: 80px;
    margin: 0 auto 20px;
  }
  p {
    font-size: 16px;
    color: #333;
    text-align: center;
  }
}
</style>
